import Page from './page';
import LoginForm from '../components/login/login-form';

export default class LoginPage extends Page {

  private loginForm: LoginForm;

  constructor(body: JQuery) {
    super();
    this.loginForm = new LoginForm(body.find('.js-loginForm'));
  }

  init(): void {
    super.init();
    this.loginForm.init();
  }
}
